<template>
	<script type="text/x-template" id="template-gamut-compress" class="template">
		<li class="block edit_block gamut-compress-block adjustment-block">
		    <div class="header-container edit_block_header drag_handle">
		        <label class="lookup_block_name name">ACES Gamut Compression</label>
		    </div>

		    <div class="block_options">
		        <div class="block-sliders-container">
		            <span class="slider-name">
                        Cyan Threshold
                         <i class="far fa-question-circle ml-1"
                            data-tippy-placement="right"
                            data-tippy-theme="info"
                            data-tippy-content="Percentage of the gamut to affect. If threshold is 0.2 the inner 80% of the gamut will be unaffected and out-of-gamut values will be compressed into the outer 20% of the gamut's colour volume."></i>
                    </span>
		            <input type="range" data-control="thC" min="0" max="0.3" value="0.15" step="0.001" class="range_slider thC_slider adjustmentBlock-slider">
					<div class="input-group --with-knob">
						<input type="text" class="input-knob" />
						<input type="number" data-control="thC" class="range_value thC_range adjustmentBlock-range" min="0" max="0.3" value="0.15" step="0.001">
					</div>
		        </div>

                <div class="block-sliders-container">
                    <span class="slider-name">
                        Magenta Threshold
                        <i class="far fa-question-circle ml-1"
                           data-tippy-placement="right"
                           data-tippy-theme="info"
                           data-tippy-content="Percentage of the gamut to affect. If threshold is 0.2 the inner 80% of the gamut will be unaffected and out-of-gamut values will be compressed into the outer 20% of the gamut's colour volume."></i>
                    </span>
                    <input type="range" data-control="thM" min="0" max="0.3" value="0.15" step="0.001" class="range_slider thM_slider adjustmentBlock-slider">
                    <div class="input-group --with-knob">
                        <input type="text" class="input-knob" />
                        <input type="number" data-control="thM" class="range_value thM_range adjustmentBlock-range" min="0" max="0.3" value="0.15" step="0.001">
                    </div>
                </div>

                <div class="block-sliders-container">
                    <span class="slider-name">
                        Yellow Threshold
                        <i class="far fa-question-circle ml-1"
                           data-tippy-placement="right"
                           data-tippy-theme="info"
                           data-tippy-content="Percentage of the gamut to affect. If threshold is 0.2 the inner 80% of the gamut will be unaffected and out-of-gamut values will be compressed into the outer 20% of the gamut's colour volume."></i>
                    </span>
                    <input type="range" data-control="thY" min="0" max="0.3" value="0.15" step="0.001" class="range_slider thY_slider adjustmentBlock-slider">
                    <div class="input-group --with-knob">
                        <input type="text" class="input-knob" />
                        <input type="number" data-control="thY" class="range_value thY_range adjustmentBlock-range" min="0" max="0.3" value="0.15" step="0.001">
                    </div>
                </div>

                <div class="block-sliders-container">
                    <span class="slider-name">
                        Cyan Distance
                        <i class="far fa-question-circle ml-1"
                           data-tippy-placement="right"
                           data-tippy-theme="info"
                           data-tippy-content="Specifies what distance will be compressed to the gamut boundary. For example, a value of 0.2 will map colours with a distance of 1.2 from the achromatic axis to 1.0, which is the gamut boundary."></i>
                    </span>
                    <input type="range" data-control="dC" min="0" max="0.4" value="0.1" step="0.001" class="range_slider dC_slider adjustmentBlock-slider">
                    <div class="input-group --with-knob">
                        <input type="text" class="input-knob" />
                        <input type="number" data-control="dC" class="range_value dC_range adjustmentBlock-range" min="0" max="0.4" value="0.1" step="0.001">
                    </div>
                </div>

                <div class="block-sliders-container">
                    <span class="slider-name">
                        Magenta Distance
                         <i class="far fa-question-circle ml-1"
                            data-tippy-placement="right"
                            data-tippy-theme="info"
                            data-tippy-content="Specifies what distance will be compressed to the gamut boundary. For example, a value of 0.2 will map colours with a distance of 1.2 from the achromatic axis to 1.0, which is the gamut boundary."></i>
                    </span>
                    <input type="range" data-control="dM" min="0" max="0.4" value="0.2" step="0.001" class="range_slider dM_slider adjustmentBlock-slider">
                    <div class="input-group --with-knob">
                        <input type="text" class="input-knob" />
                        <input type="number" data-control="dM" class="range_value dM_range adjustmentBlock-range" min="0" max="0.4" value="0.2" step="0.001">
                    </div>
                </div>

                <div class="block-sliders-container">
                    <span class="slider-name">
                        Yellow Distance
                         <i class="far fa-question-circle ml-1"
                            data-tippy-placement="right"
                            data-tippy-theme="info"
                            data-tippy-content="Specifies what distance will be compressed to the gamut boundary. For example, a value of 0.2 will map colours with a distance of 1.2 from the achromatic axis to 1.0, which is the gamut boundary."></i>
                    </span>
                    <input type="range" data-control="dY" min="0" max="0.4" value="0.1" step="0.001" class="range_slider dY_slider adjustmentBlock-slider">
                    <div class="input-group --with-knob">
                        <input type="text" class="input-knob" />
                        <input type="number" data-control="dY" class="range_value dY_range adjustmentBlock-range" min="0" max="0.4" value="0.1" step="0.001">
                    </div>
                </div>

                <div class="block-sliders-container">
                    <span class="slider-name">
                        Power
                         <i class="far fa-question-circle ml-1"
                            data-tippy-placement="right"
                            data-tippy-theme="info"
                            data-tippy-content="Indicates the &quot;strength&quot; of the effect."></i>
                    </span>
                    <input type="range" data-control="power" min="0" max="1" value="1" step="0.01" class="range_slider power_slider adjustmentBlock-slider">
                    <div class="input-group --with-knob">
                        <input type="text" class="input-knob" />
                        <input type="number" data-control="power" class="range_value power_range adjustmentBlock-range" min="0" max="1" value="1" step="0.01">
                    </div>
                </div>
		    </div>
		</li>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
